import type { Edition } from '../types';

export const TWC_STANDARD_OFFERING_ID = '7e16cb96-ade2-4220-9010-c71ef9a70cf2';
export const TWC_PREMIUM_OFFERING_ID = 'b296663a-50d7-4e51-bc53-be058da00dad';

export function getTwcOfferingIdForEdition(edition: Edition): string | undefined {
	switch (edition) {
		case 'standard':
			return TWC_STANDARD_OFFERING_ID;
		case 'premium':
			return TWC_PREMIUM_OFFERING_ID;
		default:
			return undefined;
	}
}
